// extracted by mini-css-extract-plugin
module.exports = {"list":"Navigation_list__3mWPe","disable":"Navigation_disable__nEWfs","item":"Navigation_item__2OYnj","link":"Navigation_link__3ZKk7","active":"Navigation_active__1-FWr"};